export default "__VITE_ASSET__JkY77jd7__"